// extracted by mini-css-extract-plugin
export var divider = "_fz-7";
export var itemsToggle = "_fz-8";
export var mergeModal = "_fz-1";
export var optionCard = "_fz-4";
export var radioGroup = "_fz-6";
export var radioOption = "_fz-0";
export var selected = "_fz-5";
export var shipmentOptions = "_fz-2";
export var tableOptions = "_fz-3";